import orderApi from '@/api/order'
import { generateFormHandlerMutations } from '@/helpers/forms'
import store from '@/store'

const emptyState = {
  exists: false,
  id: '',
  definition: '',
  version: 0,
  statusRaw: '',
  startedAt: null,
  finishedAt: null,
  nextRunAt: null,
  data: '',
  steps: [],
}

const state = {
  ...emptyState,
  loading: false,
  loaded: false,
}

const getters = {}

const actions = {
  async fetchWorkflow({ commit }, id) {
    commit('SET_LOADING')
    try {
      const { data } = await orderApi.getWorkflowData(id)
      commit('SET_WORKFLOW', data)
    } catch {
      commit('SET_WORKFLOW', {})
    }
  },
  async suspendWorkflow({ commit }, id) {
    try {
      await orderApi.suspendWorkflow(id)
      store.dispatch('message/success', 'Ожидание оплаты остановлено')
    } catch {
      store.dispatch('message/error', 'Не удалось остановить ожидание оплаты')
    }
  },
}

const mutations = {
  SET_LOADING(state) {
    state.loading = true
  },
  SET_WORKFLOW(state, data) {
    state.exists = data.exists === true
    state.id = data.id || ''
    state.definition = data.definition || ''
    state.version = data.version || 0
    state.statusRaw = data.status || ''
    state.startedAt = data.startedAt || null
    state.finishedAt = data.finishedAt || null
    state.nextRunAt = data.nextRunAt || null
    state.data = data.data || ''
    state.steps = data.steps || []
    state.loading = false
    state.loaded = true
  },
  ...generateFormHandlerMutations(state),
}

const modules = {}

const watchers = []

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
